<template>
  <form-field :title="title" v-bind="$attrs" is-link :is-require="isRequire" @click="onClick">
    <div v-if="!display" class="placeholder">请选择{{ title }}</div>
    <div v-else>{{ display }}</div>
    <van-popup v-model="isShow" get-container="body" position="bottom" close-on-popstate safe-area-inset-bottom>
      <van-picker v-if="isShow" show-toolbar value-key="name" :title="`选择${title}`" :columns="options" :default-index="defaultIndex" @confirm="onConfirm" @cancel="onCancel" />
    </van-popup>
  </form-field>
</template>
<style lang="less" scoped>
.placeholder {
  font-size: 32px;
  color: #bbb;
}
</style>
<script>
import { isDef } from '@/utils/common';
export default {
  name: 'FormSelect',
  props: {
    value: [String, Number, Array],
    title: String,
    isRequire: {
      type: Boolean,
      default: false,
    },
    options: Array,
  },
  data() {
    return {
      isShow: false,
    };
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    display() {
      if (isDef(this.value)) {
        const selectItem = this.options.find(item => item.id === this.value);
        return selectItem ? selectItem.name : '';
      }
    },
    defaultIndex() {
      if (isDef(this.value)) {
        const index = this.options.findIndex(item => item.id === this.value);
        return index > -1 ? index : 0;
      } else {
        return 0;
      }
    },
  },
  methods: {
    onClick() {
      this.isShow = true;
    },
    onConfirm(value) {
      this.$emit('input', value.id);
      this.$emit('change', value.id);
      this.isShow = false;
    },
    onCancel() {
      this.isShow = false;
    },
  },
};
</script>
